export default function Matplotlib_GetStarted() {
  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold">MatplotlibGetStarted Component</h1>
      <p>This is the MatplotlibGetStarted component.</p>
    </div>
  );
}
